import { RefObject, useEffect } from 'react';

// Read by the rail's stylesheet: how far the page itself has scrolled.
export const PAGE_SCROLL_PROPERTY = '--page-scroll';

interface IParams {
  railRef: RefObject<HTMLElement | null>;
  isActive?: boolean;
}

// On pages where the whole document scrolls (not an inner container) the header scrolls away, but the
// rail is fixed. The stylesheet moves its top edge up by this much, so it hugs the header and then
// the top of the window instead of hanging under an empty strip. Written on the rail itself: a custom
// property is inherited, so one on <html> re-styles every node of the page on each scroll event.
export const usePageScroll = ({ railRef, isActive }: IParams) => {
  useEffect(() => {
    const rail = railRef.current;

    if (!isActive || !rail) {
      return undefined;
    }

    const report = () => rail.style.setProperty(PAGE_SCROLL_PROPERTY, `${window.scrollY}px`);

    report();
    window.addEventListener('scroll', report, { passive: true });

    return () => window.removeEventListener('scroll', report);
  }, [railRef, isActive]);
};
